var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardCopyOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 3.33333H4.00008C3.64646 3.33333 3.30732 3.47381 3.05727 3.72386C2.80722 3.97391 2.66675 4.31304 2.66675 4.66667V12.6667C2.66675 13.0203 2.80722 13.3594 3.05727 13.6095C3.30732 13.8595 3.64646 14 4.00008 14H10.6667C11.0204 14 11.3595 13.8595 11.6096 13.6095C11.8596 13.3594 12.0001 13.0203 12.0001 12.6667V12M5.33341 3.33333C5.33341 3.68696 5.47389 4.02609 5.72394 4.27614C5.97399 4.52619 6.31313 4.66667 6.66675 4.66667H8.00008C8.3537 4.66667 8.69284 4.52619 8.94289 4.27614C9.19294 4.02609 9.33341 3.68696 9.33341 3.33333M5.33341 3.33333C5.33341 2.97971 5.47389 2.64057 5.72394 2.39052C5.97399 2.14048 6.31313 2 6.66675 2H8.00008C8.3537 2 8.69284 2.14048 8.94289 2.39052C9.19294 2.64057 9.33341 2.97971 9.33341 3.33333M9.33341 3.33333H10.6667C11.0204 3.33333 11.3595 3.47381 11.6096 3.72386C11.8596 3.97391 12.0001 4.31304 12.0001 4.66667V6.66667M13.3334 9.33333H6.66675M6.66675 9.33333L8.66675 7.33333M6.66675 9.33333L8.66675 11.3333",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCopyOutline);
export default __webpack_public_path__ + "static/media/ClipboardCopyOutline.124f80d60e67405200474eef2d4ea54a.svg";
export { ForwardRef as ReactComponent };